/**
 * 文档身份管理相关类型定义
 */
/**
 * 文档身份来源枚举
 * 用于追踪文档ID的来源
 */
export var DocumentIdentitySource;
(function (DocumentIdentitySource) {
    DocumentIdentitySource["PROPS"] = "props";
    DocumentIdentitySource["ROUTE"] = "route";
    DocumentIdentitySource["CONTEXT"] = "context";
    DocumentIdentitySource["STORAGE"] = "storage";
    DocumentIdentitySource["MANUAL"] = "manual";
})(DocumentIdentitySource || (DocumentIdentitySource = {}));
/**
 * 文档身份变更事件类型
 */
export var DocumentIdentityEventType;
(function (DocumentIdentityEventType) {
    DocumentIdentityEventType["ACTIVATED"] = "activated";
    DocumentIdentityEventType["DEACTIVATED"] = "deactivated";
    DocumentIdentityEventType["CHANGED"] = "changed";
    DocumentIdentityEventType["VALIDATED"] = "validated";
    DocumentIdentityEventType["ERROR"] = "error";
})(DocumentIdentityEventType || (DocumentIdentityEventType = {}));
/**
 * Generates a unique string key from a DocumentIdentifier.
 * @param identity The document identifier.
 * @returns A string key (e.g., "text-123", "pdf-456").
 */
export function getIdentityKey(identity) {
    if (!identity || typeof identity.id === 'undefined' || identity.id === null || !identity.type) {
        // Handle cases where identity might be incomplete, though ideally it should always be valid.
        // Consider throwing an error or returning a default/error key depending on strictness.
        console.warn('getIdentityKey called with invalid identity:', identity);
        return 'invalid-identity';
    }
    return `${identity.type}-${identity.id}`;
}
/**
 * Parses a string key (e.g., "text-123") into a DocumentIdentifier object.
 * @param key The string key to parse.
 * @returns A DocumentIdentifier object if parsing is successful, otherwise null.
 */
export function parseIdentityKey(key) {
    if (!key || typeof key !== 'string') {
        // console.warn('parseIdentityKey called with invalid key (null, undefined, or not a string):', key);
        return null;
    }
    const parts = key.split('-');
    if (parts.length !== 2) {
        // console.warn('parseIdentityKey: key format is incorrect (expected "type-id"):', key);
        return null;
    }
    const type = parts[0]; // Type assertion, relies on subsequent validation
    const idString = parts[1];
    const id = parseInt(idString, 10);
    // Basic validation for ID
    if (isNaN(id) || id <= 0) {
        // ID should be a positive number
        // console.warn('parseIdentityKey: parsed ID is invalid (NaN or not positive):', idString);
        return null;
    }
    // Validate type against known DocumentType values
    // This assumes DocumentType is defined as: export type DocumentType = 'text' | 'pdf';
    // Adjust this check if your DocumentType definition is different or more dynamic.
    if (type !== 'text' && type !== 'pdf') {
        // console.warn('parseIdentityKey: parsed type is invalid:', type);
        return null;
    }
    return { type, id };
}
//# sourceMappingURL=DocumentIdentity.js.map